import React from "react";

export const FontArial = (props: React.PropsWithChildren<{}>): JSX.Element => (
    <span
        style={{
            fontFamily: "Arial, sans-serif",
            display: "inline-flex",
        }}
    >
        {props.children}
    </span>
);
